import React from "react"
import { Link } from "gatsby"
import Helmet from "react-helmet"

// import ButtonIcon from "./ButtonIcon"
import SearchBox from "./SearchBox"

const Header = ({ showSearch = true, onSearch = () => {} }) => {
  // const filterTop = category => {
  //   console.log({ category })
  // }

  return (
    <header className="relative bg-white">
      <Helmet
        htmlAttributes={{
          lang: "es",
        }}
      >
        {/* <!-- Primary Meta Tags --> */}
        <title>Navidad Pyme 2020</title>
        <meta name="title" content="Navidad Pyme 2020" />
        <meta
          name="description"
          content="Este 30 de Noviembre, 1 y 2 de Diciembre, el día en que las Pymes de Chile se la juegan para que al momento de comprar tus regalos de Navidad, ellas sean la primera opción."
        />

        {/* <!-- Open Graph / Facebook --/> */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://navidadpyme.cl/" />
        <meta property="og:title" content="Navidad Pyme 2020" />
        <meta
          property="og:description"
          content="Este 30 de Noviembre, 1 y 2 de Diciembre, el día en que las Pymes de Chile se la juegan para que al momento de comprar tus regalos de Navidad, ellas sean la primera opción."
        />
        <meta
          property="og:image"
          content="https://navidadpyme-public-assets.s3.amazonaws.com/navidadpyme.png"
        />

        {/* <!-- Twitter --/> */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://navidadpyme.cl/" />
        <meta property="twitter:title" content="Navidad Pyme 2020" />
        <meta
          property="twitter:description"
          content="Este 30 de Noviembre, 1 y 2 de Diciembre, el día en que las Pymes de Chile se la juegan para que al momento de comprar tus regalos de Navidad, ellas sean la primera opción."
        />
        <meta
          property="twitter:image"
          content="https://navidadpyme-public-assets.s3.amazonaws.com/navidadpyme.png"
        />
        <link
          rel="apple-touch-icon-precomposed"
          sizes="57x57"
          href="/apple-touch-icon-57x57.png"
        />
        <link
          rel="apple-touch-icon-precomposed"
          sizes="114x114"
          href="/apple-touch-icon-114x114.png"
        />
        <link
          rel="apple-touch-icon-precomposed"
          sizes="72x72"
          href="/apple-touch-icon-72x72.png"
        />
        <link
          rel="apple-touch-icon-precomposed"
          sizes="144x144"
          href="/apple-touch-icon-144x144.png"
        />
        <link
          rel="apple-touch-icon-precomposed"
          sizes="60x60"
          href="/apple-touch-icon-60x60.png"
        />
        <link
          rel="apple-touch-icon-precomposed"
          sizes="120x120"
          href="/apple-touch-icon-120x120.png"
        />
        <link
          rel="apple-touch-icon-precomposed"
          sizes="76x76"
          href="/apple-touch-icon-76x76.png"
        />
        <link
          rel="apple-touch-icon-precomposed"
          sizes="152x152"
          href="/apple-touch-icon-152x152.png"
        />
        <link
          rel="icon"
          type="image/png"
          href="/favicon-196x196.png"
          sizes="196x196"
        />
        <link
          rel="icon"
          type="image/png"
          href="/favicon-96x96.png"
          sizes="96x96"
        />
        <link
          rel="icon"
          type="image/png"
          href="/favicon-32x32.png"
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href="/favicon-16x16.png"
          sizes="16x16"
        />
        <link
          rel="icon"
          type="image/png"
          href="/favicon-128.png"
          sizes="128x128"
        />
        <meta name="application-name" content="&nbsp;" />
        <meta name="msapplication-TileColor" content="#FFFFFF" />
        <meta name="msapplication-TileImage" content="mstile-144x144.png" />
        <meta name="msapplication-square70x70logo" content="mstile-70x70.png" />
        <meta
          name="msapplication-square150x150logo"
          content="mstile-150x150.png"
        />
        <meta
          name="msapplication-wide310x150logo"
          content="mstile-310x150.png"
        />
        <meta
          name="msapplication-square310x310logo"
          content="mstile-310x310.png"
        />
      </Helmet>
      <a className="sr-only" href="/#maincontent">
        Saltar al contenido principal
      </a>
      <div className="px-4 sm:px-6 border-b-2 border-gray-100">
        <div className="max-w-7xl mx-auto flex flex-auto justify-between items-center py-6 md:justify-start md:space-x-10">
          <div
            className="flex justify-start lg:w-0 lg:flex-1"
            style={{ maxWidth: 150 }}
          >
            <Link to="/">
              <span className="sr-only">Navidad Pyme 2020</span>
              <img
                className="h-16 w-auto sm:h-16"
                src="/images/logo-navidadpyme.svg"
                alt="Navidad Pyme 2020"
              />
            </Link>
          </div>
          <div className="-mr-2 -my-2 md:hidden"></div>
          <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
            {showSearch && (
              <SearchBox
                placeholder="Encuentra tu regalo..."
                onChange={onSearch}
                onSubmit={onSearch}
              />
            )}
          </div>
          {/* <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
            <ButtonIcon
              image="/images/tienda-icon.svg"
              title="Tiendas"
              onClick={() => filterTop("tiendas")}
            />
            <ButtonIcon
              image="/images/rest-icon.svg"
              title="Restaurantes"
              onClick={() => filterTop("restaurantes")}
            />
            <ButtonIcon
              image="/images/servicios-icon.svg"
              title="Servicios"
              onClick={() => filterTop("servicios")}
            />
          </div> */}
        </div>
      </div>
    </header>
  )
}

export default Header
